import React from 'react';

const IcFunnel = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>;
const IcShield = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>;
const IcTrendUp = () => <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>;

const CARDS = [
    {
        ghost: '£0',
        bg: '#4A67FF',
        shadow: 'rgba(74,103,255,.30)',
        icon: <IcFunnel />,
        title: 'Free qualified deal flow',
        text: 'Come onto our platform for free, and receive qualified, pre- diligenced dealflow from our companies, vc and advisors already on our paltform.',
    },
    {
        ghost: '60%',
        bg: '#FC7785',
        shadow: 'rgba(252,119,133,.30)',
        icon: <IcShield />,
        title: 'AI diligence at a fraction of the cost',
        text: 'Enable your companies to be quickly pre-diligenced in days prior to going to the expense of full diligence.',
    },
    {
        ghost: 'Gold',
        bg: '#1F8A5B',
        shadow: 'rgba(31,138,91,.30)',
        icon: <IcTrendUp />,
        title: 'Speed your portfolio exits',
        text: 'Keep your portfolio companies always “exit ready.',
    },
];

const PEWhySection = () => (
    <section className="lp-pe-why">
        <div className="lp-pe-why-head">
            <div className="lp-pe-eyebrow" data-lp-reveal>Why Diligentsia</div>
            <h2 className="lp-h2" style={{ margin: '0 auto', maxWidth: 'none' }} data-lp-reveal>Exit quicker, at higher valuations.</h2>
        </div>

        <div className="lp-pe-cards">
            {CARDS.map((c, i) => (
                <div className="lp-pe-card" key={i} data-lp-reveal data-lp-delay={i * 100}>
                    <div className="lp-pe-card-ghost" aria-hidden="true">{c.ghost}</div>
                    <div className="lp-pe-card-icon" style={{ background: c.bg, boxShadow: `0 8px 20px ${c.shadow}` }}>{c.icon}</div>
                    <h3>{c.title}</h3>
                    <p>{c.text}</p>
                </div>
            ))}
        </div>
    </section>
);

export default PEWhySection;
